// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3SM-x","signatureButtonsRight":"ModalSign_signatureButtonsRight__3ItL7"};